<template>
  <div class="tax-setup-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "taxSetupBase",
};
</script>
